/* eslint-disable */
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface CurrentCustomerBillTosModel extends BaseModel {
    users: string[];
}

export function getCurrentCustomerBillTos() {
    return get<CurrentCustomerBillTosModel>("/api/v1/webUsersExtended/fromCurrentBillTo", {});
}
